import CryptoJS from 'crypto-js'

export function deviceEncrypt(e) {
    if (e) {
        let t = new Date(),
            r = (t.getFullYear(), t.getMonth(), t.getDate(), e),
            n = CryptoJS.MD5('!QAZ1qaza@#$12&*'),
            i = CryptoJS.enc.Utf8.parse(n),
            o = CryptoJS.enc.Utf8.parse('!QAZ1qaza@#$12&*'),
            a = CryptoJS.AES.encrypt(r, i, {
                iv: o,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.ZeroPadding,
            })
        let T = a.toString()
        return T
    }
}

export default {
    deviceEncrypt,
}


// WEBPACK FOOTER //
// ./src/common/js/encrypt.js